module.exports = __webpack_public_path__ + "img/gt.4766b57d.svg";